import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Qr from '@src/components/qr';
import GuestStore from './store';

const styles = require('./index.less');

const DEFAULT_VIEW_MODEL = {
  qrVisible: true,
  wechatVisible: false,
  likeButtonVisible: false,
  likedButtonVisible: false,
  joinButtonVisible: true,
  canLike: false,
  qrValue: ''
};

const Guest = ({ className, store, viewModel = DEFAULT_VIEW_MODEL, onLike, onJoin, onInvite = onJoin }) => {
  store.use();
  const model = {
    ...DEFAULT_VIEW_MODEL,
    ...viewModel
  };

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.group1} data-name="客态页">
        <div className={cx(styles.group2, model.qrVisible ? styles.isVisible : styles.isHidden)} data-name="非微信环境打开时页面显示内容">
          <div className={styles.group3} data-name="二维码">
            <div className={styles.layer2} data-name="二维码边框" />
            <div className={styles.layer1} data-name="二维码占位">
              {model.qrValue && <Qr value={model.qrValue} size={220} renderAs="png" />}
            </div>
          </div>

          <div className={styles.layer3} data-name="文案" />
          <div className={styles.layer4} data-name="按钮-邀好友点赞" role="button" tabIndex={0} onClick={onInvite} />
        </div>

        <div className={cx(styles.group4, model.wechatVisible ? styles.isVisible : styles.isHidden)} data-name="微信环境打开时页面显示内容">
          <div className={styles.group5} data-name="文案">
            <div className={styles.layer6} data-name="框" />
            <div className={styles.layer5} data-name="一别江湖许久， 今逢十八周年盛典。 诚邀好友点赞共贺， 助我解锁获得更多连抽机会， 同享江湖盛事！" />
          </div>

          <div className={styles.group6} data-name="按钮-点赞">
            <div
              className={cx(styles.layer7, model.likedButtonVisible ? styles.isVisible : styles.isHidden)}
              data-name="按钮-已点赞（置灰）"
              role="button"
              tabIndex={model.likedButtonVisible ? 0 : -1}
              onClick={model.likedButtonVisible ? onLike : undefined}
            />
            <div
              className={cx(styles.layer8, model.likeButtonVisible ? styles.isVisible : styles.isHidden)}
              data-name="按钮-帮TA点赞"
              role="button"
              tabIndex={model.canLike ? 0 : -1}
              onClick={model.canLike ? onLike : undefined}
            />
          </div>

          <div
            className={cx(styles.layer9, model.joinButtonVisible ? styles.isVisible : styles.isHidden)}
            data-name="按钮-我也要参加"
            role="button"
            tabIndex={0}
            onClick={onJoin}
          />
        </div>

        <div className={styles.layer10} data-name="背景" />
      </div>
    </div>
  );
};

export default wrapStore(Guest, GuestStore);
